module.exports = __webpack_public_path__ + "media/images/home/hero-poster-mobile-e5a1063a011f3378e1e5755724240c24.jpg";